import { Button, Modal, Form, OverlayTrigger, Tooltip, Row, Col, Spinner, Tabs, Tab } from 'react-bootstrap'
import { useEffect, useState, useRef, useCallback } from 'react';
import { RoomContext, AudioTrack } from '@livekit/components-react';
import { ConnectionState } from "@livekit/components-react";
import { Participant, Room, RoomEvent } from 'livekit-client';
import axios from 'axios';

import { Track } from "livekit-client";
import { GridLayout, useTracks, ParticipantTile, VideoConference, AudioConference, useTrackByName, useParticipants, RoomAudioRenderer, AudioVisualizer, BarVisualizer, useVoiceAssistant, ParticipantAudioTile, ParticipantLoop, ParticipantName, TrackLoop, useTrackToggle, TrackToggle, useTranscriptions, LayoutContextProvider, Chat, useConnectionState } from "@livekit/components-react";
import '@livekit/components-styles';
import '../../App.css';

import 'groq-sdk/shims/web';
import Groq from 'groq-sdk';

// Strip Cartesia TTS voice tags (e.g. <emotion value="...">text</emotion>, <trust:medium>, etc.)
function stripVoiceTags(text) {
	if (!text) return text;
	return text.replace(/<[^>]+>/g, '').trim();
}

const groq = new Groq({
	// The SDK automatically uses the GROQ_API_KEY from the environment
	apiKey: process.env.REACT_APP_GROQ_API_KEY, //(for CRA)
	dangerouslyAllowBrowser: true, // Only use this option if you understand the security implications
});

const PauseButton = ({ variant }) => {

	const { buttonProps, enabled } = useTrackToggle({
		source: Track.Source.Microphone,
		initialState: true
	});

	return (
		<></>
		// <Button variant='dark' onClick={buttonProps.onClick} className={`rounded-circle d-flex align-items-center justify-content-center shadow ${variant ? variant : 'pause-btn'}`}>
		//     <i className={`bi ${enabled ? "bi-pause-fill" : "bi-play-fill"}`} />
		// </Button>
	);
};


function MyAudioConference(props) {
	const [widgetState, setWidgetState] = useState({
		showChat: false,
		unreadMessages: 0,
	});

	const audioTracks = useTracks([Track.Source.Microphone]);

	console.log('Audio Tracks:', audioTracks);
	//  useWarnAboutMissingStyles();

	return (
		<LayoutContextProvider onWidgetChange={setWidgetState}>
			{/* <div className="lk-audio-conference" {...props} width="100%"> */}
			{/* <div className="lk-audio-conference-stage" width="100%"> */}
			{audioTracks[1] && <ParticipantAudioTile trackRef={audioTracks[1]} width="100%" />}
			{/* {audioTracks[0] && <ParticipantAudioTile trackRef={audioTracks[0]} width="50%" />} */}
			{/* <TrackLoop tracks={audioTracks}>
			   <ParticipantAudioTile width="50%" />
			 </TrackLoop> */}
			{/* </div> */}
			{/* </div> */}
		</LayoutContextProvider>
	);
}

async function getSummary(conversation) {

	const prompt = `Summarize the following conversation between a user and an agent in a concise manner:\n\n${conversation}\n\nSummary: \n ${conversation}`;
	const chatCompletion = await groq.chat.completions.create({
		messages: [
			{
				role: "user",
				content: prompt,
			},
		],
		model: "llama-3.1-8b-instant", // Choose a model from the Groq console
	});

	return chatCompletion.choices[0]?.message?.content || ""

}

function TranscriptModal({ show, onHide, transcript, recording }) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Transcript</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                {recording && (
                    <div className="mb-3 text-muted small">
                        <strong>Session:</strong> {new Date(recording.created_at).toLocaleString()}
                    </div>
                )}
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {transcript ? stripVoiceTags(transcript) : <i className="text-muted">No transcript available for this session.</i>}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

function ChatBox({ room, summaryText, activeTab, selectedAgent, testprompt, setTestPrompt, testFirstMessage, setTestFirstMessage, agentFiles, localTranscriptions, setLocalTranscriptions, isConnected, agentReady, agentRecordings, fetchRecordings }) {
	const transcriptions = useTranscriptions();
	const connectionState = useConnectionState(room);
	const [summary, setSummary] = useState(summaryText || '');
	const [saving, setSaving] = useState(false);
    const [showTranscriptModal, setShowTranscriptModal] = useState(false);
    const [selectedTranscript, setSelectedTranscript] = useState('');
    const [selectedRecording, setSelectedRecording] = useState(null);

    const handleShowTranscript = (rec) => {
        setSelectedRecording(rec);
        setSelectedTranscript(rec.transcript);
        setShowTranscriptModal(true);
    };


	const boxRef = useRef(null);

	// setTestPrompt(selectedAgent.prompt);
	// setTestFirstMessage(selectedAgent.firstmessage);

	useEffect(() => {
		if (boxRef.current) {
			boxRef.current.scrollTop = boxRef.current.scrollHeight;
		}
		if (transcriptions.length > 0)
			setLocalTranscriptions(transcriptions);
	}, [transcriptions]);

	useEffect(() => {
		const fetchSummary = async () => {
			if (connectionState === 'disconnected' && localTranscriptions.length > 0) {
				let conversation = ''
				localTranscriptions.forEach((transcription) => {
					const speaker = transcription.participantInfo.identity.includes("agent") ? "Agent" : "User";
					conversation += `${speaker}: ${stripVoiceTags(transcription.text)}\n`;
				});
				console.log('Final Conversation:\n', conversation);
				const summary = await getSummary(conversation);
				console.log('Conversation Summary:', summary);
				setSummary(summary);
			}
		}
		fetchSummary();
	}, [connectionState]);

	// Render based on selected tab: 'transcription' or 'summary'
	if (activeTab === 'summary') {
		return (
			<Row style={{ height: '61vh' }}>
				<Col>
					<div className="p-3 m-2 shadow-sm rounded h-100"><strong>Summary:</strong>
						<div className='mt-2'>{summary}</div>
					</div>
				</Col>
			</Row>
		);
	}

	if (activeTab === 'prompt') {
		return (
			<>
				<Row>
					<Col>
						<Form.Group className="mb-3" >
							<Form.Control required name='prompt' as="textarea" rows={18} value={testprompt || selectedAgent.prompt} onChange={(e) => { setTestPrompt(e.target.value) }} />
						</Form.Group>
					</Col>
				</Row>
				<Row>
					<Col>
						<Form.Group className="mb-3" >
							<Form.Label>First Message</Form.Label>
							<Form.Control name='firstmessage' value={testFirstMessage || selectedAgent.firstmessage} onChange={(e) => { setTestFirstMessage(e.target.value) }} type="text" />
						</Form.Group>
					</Col>

				</Row>
				<Row>
					<Col className="d-flex justify-content-end">
						<Button variant="primary" onClick={async () => {
							try {
								setSaving(true);
								const payload = {
									agentid: selectedAgent.id,
									prompt: testprompt || selectedAgent.prompt,
									firstmessage: testFirstMessage || selectedAgent.firstmessage
								};
								const result = await axios.post('/updatevoiceagentprompt', payload);
								if (result && result.data && result.data.ok) {
									alert('Saved successfully');
								} else {
									alert('Saved');
								}
							} catch (err) {
								console.error(err);
								alert('Failed to save');
							} finally {
								setSaving(false);
							}
						}} disabled={saving}>
							{saving ? 'Saving...' : 'Save'}
						</Button>
					</Col>
				</Row>
			</>
		);
	}

	if (activeTab === 'files') {
		return (
			<Row style={{ height: '61vh' }}>
				<Col>
					<div className="p-3 m-2 shadow-sm rounded h-100" style={{ overflowY: 'auto' }}>
						<div className='mt-3'>
							{agentFiles && agentFiles.length > 0 ? (
								<ul className="list-group">
									{agentFiles.map((file, idx) => (
										<li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
											<span>{file.name}</span>
											<Button
												variant="outline-primary"
												size="sm"
												onClick={() => window.open(`/voiceagent/file/${selectedAgent.id}/${file.name}`, '_blank')}
											>
												Open
											</Button>
										</li>
									))}
								</ul>
							) : (
								<p className="text-muted">No files found.</p>
							)}
						</div>
					</div>
				</Col>
			</Row>
		);
	}

    if (activeTab === 'recordings') {
		return (
			<Row style={{ height: '61vh' }}>
				<Col>
					<div className="p-3 m-2 shadow-sm rounded h-100 d-flex flex-column" style={{ overflow: 'hidden' }}>
                        <div className="d-flex justify-content-between align-items-center flex-shrink-0">
                            <strong></strong>
                            <Button size="sm" variant="outline-primary" onClick={fetchRecordings}>Refresh</Button>
                        </div>
						<div className='mt-3' style={{ overflowY: 'auto', overflowX: 'hidden', flex: '1 1 0', minHeight: 0 }}>
							{agentRecordings && agentRecordings.length > 0 ? (
								<ul className="list-group list-group-flush">
									{agentRecordings.map((rec, idx) => (
										<li key={idx} className="list-group-item p-2">
                                            <Row className="align-items-center">
                                                <Col xs={3}>
                                                    <div style={{fontSize: '0.85em', fontWeight: 'bold'}}>{rec.user_name || 'Unknown User'}</div>
                                                    <div className="text-muted" style={{fontSize: '0.75em'}}>
                                                        {new Date(rec.created_at).toLocaleString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                                    </div>
                                                </Col>
                                                <Col xs={2} className="text-center">
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>View Transcript</Tooltip>}>
                                                        <Button variant="light" size="sm" onClick={() => handleShowTranscript(rec)}>
                                                            <i className="bi bi-file-text"></i>
                                                        </Button>
                                                    </OverlayTrigger>
                                                </Col>
                                                <Col xs={7}>
                                                    <audio controls src={rec.filepath} style={{width: '100%', height: '30px'}} className="my-1">
                                                        Your browser does not support the audio element.
                                                    </audio>
                                                </Col>
                                            </Row>
										</li>
									))}
								</ul>
							) : (
								<p className="text-muted small">No recordings found.</p>
							)}
						</div>
					</div>
                     <TranscriptModal 
                        show={showTranscriptModal} 
                        onHide={() => setShowTranscriptModal(false)} 
                        transcript={selectedTranscript}
                        recording={selectedRecording} 
                    />
				</Col>
			</Row>
		);
	}

	return (
		<Row style={{ height: '61vh' }}>
			<Col>
				<div className="p-3 m-2 shadow-sm rounded chat-box" ref={boxRef}>
					{isConnected && !agentReady ? (
						<div className="d-flex flex-column justify-content-center align-items-center h-100">
							<Spinner animation="border" variant="primary" />
							<p className="mt-3 text-muted">Connecting to agent...</p>
						</div>
					) : (
						localTranscriptions.map((transcription, idx) => (
							<div key={idx}
								style={{
									display: "flex",
									justifyContent: transcription.participantInfo.identity.includes("agent")
										? "flex-start"
										: "flex-end",
									marginBottom: "10px",
								}}
							>
								<div className={`text-start ${transcription.participantInfo.identity.includes("agent") ? "bg-primary" : "bg-light"}`}
									style={{
										maxWidth: "70%",
										padding: "10px 14px",
										borderRadius: "12px",
										color: transcription.participantInfo.identity.includes("agent") ? "#ffffff" : "#333",
										fontSize: "14px",
										lineHeight: "1.4",
									}}
								>
									<strong>
										{transcription.participantInfo.identity.includes("agent") ? "Agent" : "You"}:
									</strong>{" "}
									{stripVoiceTags(transcription.text)}
								</div>
							</div>
						))
					)}
				</div>
			</Col>
		</Row>
	);
}

function TestAgentModal(props) {
	const [room] = useState(() => new Room({}));
	const [activeTab, setActiveTab] = useState('transcription');
	// You can manage room connection lifecycle here
	const [loading, setLoading] = useState(false);
	const [isConnected, setIsConnected] = useState(false);
	const [agentName, setAgentName] = useState('');
	const [personName, setPersonName] = useState('');
	const [companyName, setCompanyName] = useState('');
	const [personRole, setPersonRole] = useState('');
	const [summaryText, setSummaryText] = useState('');
	const [testprompt, setTestPrompt] = useState('');
	const [testFirstMessage, setTestFirstMessage] = useState('');
	const [agentFiles, setAgentFiles] = useState([]);
	const [agentRecordings, setAgentRecordings] = useState([]);
	const [localTranscriptions, setLocalTranscriptions] = useState([]);
	const [agentReady, setAgentReady] = useState(false);

	function getRandomInt(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min) + min);
	}

	function replaceDynamicVariables(text) {
		if (!text || typeof text !== 'string') return text;
		const replacements = {
			'[Person_Name]': personName || '',
			'[Company_Name]': companyName || '',
			'[Person_Role]': personRole || ''
		};
		return text.replace(/\[Person_Name\]|\[Company_Name\]|\[Person_Role\]/g, (match) => replacements[match] ?? match);
	}

	const connect = async () => {
		setLoading(true);
		setSummaryText('');
		setActiveTab('transcription');
		setLocalTranscriptions([]);
		setAgentReady(false);

		const userid = props.uid;
		const loggedInUserName = props.loggedInUserName;
		//create room
		const roomName = `testroom-${userid}-${getRandomInt(1000, 9999)}`;
		const agent_name = `testagent-${props.selectedAgent.id}-${getRandomInt(1000, 9999)}`;
		setAgentName(agent_name)

		const participantName = loggedInUserName ?? 'test-user';
		console.log('Room Name:', roomName, 'Participant Name:', participantName);
		await createroom(roomName, participantName);
		//create agent and add to room
		await createtestsession(roomName, props.selectedAgent, agent_name);
		// console.log('Agent', JSON.stringify(props.selectedAgent));
		room.startAudio()
		setIsConnected(true);
		setLoading(false);
	}

	async function createroom(roomName, participantName) {
		const result = await axios.get(`/getLivekitToken/${roomName}/${participantName}`)
		console.log('Livekit token', result.data);
		await room.connect(process.env.REACT_APP_LIVEKIT_URL, result.data, {
			autoSubscribe: true,
		});
		// Keep mic disabled until agent is ready
		await room.localParticipant.setMicrophoneEnabled(false);
	}

	async function createtestsession(roomName, agent, agent_name) {
		console.log('Creating test session for agent:', agent);
		console.log('Dynamic variables:', { personName, companyName, personRole });
		const instructions = replaceDynamicVariables(testprompt || agent.prompt);
		const firstmessage = replaceDynamicVariables(testFirstMessage || agent.firstmessage);
		console.log('After replacement - instructions:', instructions.substring(0, 200));
		console.log('After replacement - firstmessage:', firstmessage);

		const data = {
			"user_id": props.uid,
			"agent_id": props.selectedAgent.id,
			"agent_name": agent_name,
			"instructions": instructions,
			"firstmessage": firstmessage,
			"room_name": roomName,
			"voiceprovider": agent.voiceprovider,
			"voicemodel": agent.voicemodel,
			"voiceid": agent.voicevoiceid
		};
		const result = await axios.post(`/start_test_session`, data)
		console.log('Test agent session start result', result.data);
	}

	const stoptestsession = useCallback(async () => {
		console.log('Stopping test session...');
		setLoading(true);
		room.disconnect();
		setSummaryText('');
		try {
			const result = await axios.post(`/stop_agent`, {
				"agent_name": agentName
			});
			console.log('Stop agent response:', result.data);
		} catch (error) {
			console.error('Error stopping agent:', error);
		}

		setIsConnected(false);
		// switch to summary tab when stopping the session
		setActiveTab('summary');
		setLoading(false);
	}, [room, agentName]);

	useEffect(() => {
		const onParticipantDisconnected = (participant) => {
			if (participant.identity === agentName || participant.identity.startsWith('agent-')) {
				stoptestsession();
			}
		};

		if (room) {
			room.on(RoomEvent.ParticipantDisconnected, onParticipantDisconnected);
		}

		return () => {
			if (room) {
				room.off(RoomEvent.ParticipantDisconnected, onParticipantDisconnected);
			}
		};
	}, [room, agentName, stoptestsession]);

	// Track when agent is ready (connected and publishing audio)
	useEffect(() => {
		const onTrackSubscribed = (track, publication, participant) => {
			console.log('Track subscribed:', participant.identity, track.kind);
			if (participant.identity.includes('agent') && track.kind === 'audio') {
				console.log('Agent audio track subscribed, agent is ready');
				setAgentReady(true);
			}
		};

		const onParticipantConnected = (participant) => {
			console.log('Participant connected:', participant.identity);
			// Check if agent participant already has audio tracks
			if (participant.identity.includes('agent')) {
				setTimeout(() => {
					const audioTracks = participant.getTrackPublications();
					console.log('Agent tracks:', Array.from(audioTracks.values()).map(t => t.kind));
					const hasAudio = Array.from(audioTracks.values()).some(t => t.kind === 'audio' && t.track);
					if (hasAudio) {
						console.log('Agent already has audio track, setting ready');
						setAgentReady(true);
					}
				}, 1000); // Small delay to ensure tracks are available
			}
		};

		if (room) {
			room.on(RoomEvent.TrackSubscribed, onTrackSubscribed);
			room.on(RoomEvent.ParticipantConnected, onParticipantConnected);

			// Also check existing participants in case agent is already connected
			const participants = Array.from(room.remoteParticipants.values());
			console.log('Existing participants:', participants.map(p => p.identity));
			participants.forEach(participant => {
				if (participant.identity.includes('agent')) {
					const audioTracks = participant.getTrackPublications();
					const hasAudio = Array.from(audioTracks.values()).some(t => t.kind === 'audio' && t.track);
					if (hasAudio) {
						console.log('Existing agent has audio, setting ready immediately');
						setAgentReady(true);
					}
				}
			});
		}

		return () => {
			if (room) {
				room.off(RoomEvent.TrackSubscribed, onTrackSubscribed);
				room.off(RoomEvent.ParticipantConnected, onParticipantConnected);
			}
		};
	}, [room, agentName]);

	// Enable microphone only after the agent is ready
	useEffect(() => {
		if (agentReady && isConnected && room) {
			console.log('Agent is ready, enabling microphone');
			room.localParticipant.setMicrophoneEnabled(true);
		}
	}, [agentReady, isConnected, room]);

	useEffect(() => {
		setActiveTab('transcription');
        if (activeTab === 'recordings' && props.selectedAgent && props.selectedAgent.id) {
            fetchRecordings();
        }
		return () => {
			// Clean up the room when the component unmounts
			setActiveTab('transcription');
			setTestPrompt('');
			setTestFirstMessage('');
			setLoading(false);
			if (room.state === 'connected') {
				room.disconnect();
			}
		};
	}, []);

    const fetchRecordings = async () => {
        if (props.selectedAgent && props.selectedAgent.id) {
            try {
                const resp = await axios.get(`/voiceagent/recordings/${props.selectedAgent.id}`);
                if (resp && resp.data) {
                    setAgentRecordings(resp.data);
                }
            } catch (err) {
                console.error('Error fetching agent recordings', err);
            }
        }
    };

    useEffect(() => {
        if (activeTab === 'recordings') {
            fetchRecordings();
        }
    }, [activeTab, props.selectedAgent]);

	useEffect(() => {
		if (props.showtestagentmodal && props.selectedAgent && props.selectedAgent.id) {
			const fetchAgentFiles = async () => {
				try {
					const resp = await axios.get(`/voiceagent/files/${props.selectedAgent.id}`);
					if (resp && resp.data) {
						setAgentFiles(resp.data);
					}
				} catch (err) {
					console.error('Error fetching agent files', err);
				}
			};
			fetchAgentFiles();
		}
	}, [props.showtestagentmodal, props.selectedAgent]);

	return (
		<>  <RoomContext.Provider data-lk-theme="default" value={room} >
			<Modal
				show={props.showtestagentmodal}
				onHide={() => {
					if (isConnected && !window.confirm("Are you sure you want to close the call?")) {
						return;
					}
					stoptestsession();
					props.setShowtestagentmodal(false);
					setActiveTab('transcription');
					setTestPrompt('')
					setTestFirstMessage('')
				}}
				centered
				size="xl"
				backdrop="static" keyboard={false}
			>
				<Modal.Header closeButton={true} >
					<div className="fs-6">Test Agent</div>
				</Modal.Header>
				<Modal.Body className="m-1 p-3">
					<Row>
						<Col xs={12} md={6}>
							<Row>
								<div className="d-flex justify-content-center align-items-center mb-4">
									<img src="/sales_rep.png" alt="Sales Rep" style={{ width: 200, height: 200, objectFit: 'contain' }} />
								</div>
							</Row>
							{/* <SimpleVoiceAssistant/> */}
							{/* <MyAudioTrack selectedAgent={props.selectedAgent} /> */}

							{/* <RoomAudioRenderer /> */}

							{/* <SimpleVoiceAssistant/> */}
							<Row style={{ height: '20vh' }} className="px-4">

								{/* <AudioConference style={{margin:"auto"}}/> */}
								{/* <AgentOnlyVisualizer agentIdentity={`testagent-${props.selectedAgent.id}`} /> */}
								{/* <StartAudioOnce/> */}
								{isConnected && !agentReady ? (
									<div className="d-flex flex-column justify-content-center align-items-center h-100">
										<Spinner animation="border" variant="primary" />
										<p className="mt-3 text-muted">Connecting to agent...</p>
									</div>
								) : (
									<MyAudioConference />
								)}
								{/* <DebugParticipants/> */}
							</Row>
							<Row className="mt-3 mb-3 px-4">
								<Col xs={12}>
									<div className="p-3 border rounded shadow-sm bg-light">
										<div className="mb-3">
											<h6 className="text-secondary mb-0">
												Dynamic Variables
											</h6>
											<small className="text-muted">Customize the agent's conversation context</small>
										</div>
										<Row>
											<Col md={4} className="mb-2">
												<Form.Group controlId="personName">
													<Form.Label className="small text-muted mb-1">
														[Person_Name]
														<i className="bi bi-copy ms-2" style={{ cursor: 'pointer' }} title="Copy [Person_Name]" onClick={() => navigator.clipboard.writeText('[Person_Name]')}></i>
													</Form.Label>
													<Form.Control
														size="sm"
														type="text"
														placeholder="Enter name"
														value={personName}
														onChange={e => setPersonName(e.target.value)}
														disabled={isConnected}
													/>
												</Form.Group>
											</Col>
											<Col md={4} className="mb-2">
												<Form.Group controlId="companyName">
													<Form.Label className="small text-muted mb-1">
														[Company_Name]
														<i className="bi bi-copy ms-2" style={{ cursor: 'pointer' }} title="Copy [Company_Name]" onClick={() => navigator.clipboard.writeText('[Company_Name]')}></i>
													</Form.Label>
													<Form.Control
														size="sm"
														type="text"
														placeholder="Enter company"
														value={companyName}
														onChange={e => setCompanyName(e.target.value)}
														disabled={isConnected}
													/>
												</Form.Group>
											</Col>
											<Col md={4} className="mb-2">
												<Form.Group controlId="personRole">
													<Form.Label className="small text-muted mb-1">
														[Person_Role]
														<i className="bi bi-copy ms-2" style={{ cursor: 'pointer' }} title="Copy [Person_Role]" onClick={() => navigator.clipboard.writeText('[Person_Role]')}></i>
													</Form.Label>
													<Form.Control
														size="sm"
														type="text"
														placeholder="Enter role"
														value={personRole}
														onChange={e => setPersonRole(e.target.value)}
														disabled={isConnected}
													/>
												</Form.Group>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
							{/* <VideoConference /> */}
							{/* <ConnectionState /> */}
							<Row>
								<div className="controls d-flex justify-content-center align-items-center mb-2 gap-3" style={{ maxWidth: "700px", bottom: "1rem" }}>
									{isConnected && (
										<div className="d-flex align-items-center">
											<TrackToggle source={Track.Source.Microphone} initialState={true} />
											<span className="ms-0 ms-md-1">Microphone</span>
										</div>
									)}
									<PauseButton />
									<Button className='px-md-5 px-3 d-flex align-items-center justify-content-center' variant={isConnected ? "danger" : "success"} onClick={() => { isConnected ? stoptestsession() : connect() }} disabled={loading}>
										{loading ? (
											<>
												<Spinner animation="border" size="sm" role="status" className="me-2" />
												{isConnected ? 'Stopping...' : 'Starting...'}
											</>
										) : (
											(isConnected ? 'Stop' : 'Start')
										)}
									</Button>
								</div>
							</Row>
						</Col>
						<Col xs={12} md={6} className='mt-2' style={{ overflow: "hidden" }}>

							<Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="justify-content-start">
								<Tab eventKey="transcription" title="Transcription" />
								<Tab eventKey="prompt" title="Prompt" />
								<Tab eventKey="summary" title="Summary" />
								<Tab eventKey="files" title="Knowledge Base" />
                                <Tab eventKey="recordings" title="Recordings" />
							</Tabs>



							<ChatBox
								room={room}
								summaryText={summaryText}
								activeTab={activeTab}
								selectedAgent={props.selectedAgent}
								testprompt={testprompt}
								setTestPrompt={setTestPrompt}
								testFirstMessage={testFirstMessage}
								setTestFirstMessage={setTestFirstMessage}
								agentFiles={agentFiles}
                                agentRecordings={agentRecordings}
                                fetchRecordings={async () => {
                                    if(props.selectedAgent && props.selectedAgent.id) {
                                        try {
                                            const res = await axios.get(`/voiceagent/recordings/${props.selectedAgent.id}`);
                                            if(res && res.data) setAgentRecordings(res.data);
                                        } catch(e) { console.error(e); }
                                    }
                                }}
								localTranscriptions={localTranscriptions}
								setLocalTranscriptions={setLocalTranscriptions}
								isConnected={isConnected}
								agentReady={agentReady}
							/>

						</Col>

					</Row>
				</Modal.Body>
				{/* <Modal.Footer style={{ justifyContent: "flex-start" }}>
					<p className="mx-1">Note : You cannot run campaign for a paused list. Please wait for the List to get completed or Stop the crawl Job to run a campaign on that list</p>
				</Modal.Footer> */}
			</Modal>
		</RoomContext.Provider>
		</>
	)
}

export default TestAgentModal